export default {"src":"https://assets.willie.be/90f463b4557c962e/_next/static/media/login.30139838.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};